import clsx from "clsx";
import type { useTranslations } from "next-intl";
import Link from "next/link";

type Props = {
  type: "hotels" | "flights";
  t: ReturnType<typeof useTranslations>;
};

export const Switch = ({ type, t }: Props) => {
  return (
    <div className="rounded-full bg-white px-4 py-2.5 flex gap-2 dark:bg-dark">
      <Link
        className={clsx(
          "block rounded-full font-inter font-medium py-1.5 px-8",
          type === "hotels"
            ? "bg-sleap-purple-300 text-white"
            : "hover:text-sleap-purple-300"
        )}
        href="/"
      >
        {t("hotels")}
      </Link>
      <Link
        className={clsx(
          "block rounded-full font-inter  font-medium py-1.5 px-8",
          type === "hotels"
            ? "hover:text-sleap-purple-300"
            : "bg-sleap-purple-300 text-white"
        )}
        href="/flights"
      >
        {t("flights")}
      </Link>
    </div>
  );
};
